export interface UserFormState {
    id?: number;
    name: string | null;
    email: string | null;
    password?: string | null;
    confirmPassword?: string | null;
    roles: number[];
    levels: number[];
    standardLevelId: number | null;
    isActive: boolean;
    extensionNumber: number | null;
    numberId: number | null;
    useSmartCallerId?: boolean;
    useAutoAttendant?: boolean;
    devices: UserDeviceFormState;
}

export interface UserDeviceFormState {
    mobile: boolean;
    desktop: boolean;
    web: boolean;
    external: boolean;
}
